import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Heading, Secondary, SvgIcon } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import cx from "classnames";
import { useRef, useState } from "react";
import { SlideDown } from "react-slidedown";
import PartnerCard from "./partner-card/partner-card";
import styles from "./partners-overview.module.css";
export var DEFAULT_PARTNER_CARDS_LENGTH = 5;
var PartnersOverview = function(blok) {
    var ref = useState(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var ref1 = useRef(null);
    var handleClick = function() {
        var ref, ref2, ref3;
        isExpanded ? (ref = ref1.current) === null || ref === void 0 ? void 0 : (ref2 = ref.scrollIntoView) === null || ref2 === void 0 ? void 0 : ref2.call(ref, {
            block: "center"
        }) : (ref3 = ref1.current) === null || ref3 === void 0 ? void 0 : ref3.focus();
        setIsExpanded(function(prevState) {
            return !prevState;
        });
    };
    var partnerCards = isExpanded ? blok.partners : blok.partners.slice(0, DEFAULT_PARTNER_CARDS_LENGTH);
    return /*#__PURE__*/ _jsxs("section", _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: blok.heading
            }),
            /*#__PURE__*/ _jsx(SlideDown, {
                as: "ul",
                className: styles.listContainer,
                "data-expanded": isExpanded,
                children: partnerCards.map(function(partner, idx) {
                    return /*#__PURE__*/ _createElement(PartnerCard, _object_spread_props(_object_spread({}, partner), {
                        key: partner._uid,
                        innerRef: idx === DEFAULT_PARTNER_CARDS_LENGTH - 1 ? ref1 : undefined
                    }));
                })
            }),
            /*#__PURE__*/ _jsxs(Secondary, {
                classNames: {
                    button: styles.button
                },
                element: "button",
                onClick: function() {
                    return handleClick();
                },
                children: [
                    "Show ".concat(isExpanded ? "fewer" : "all", " partnerships"),
                    /*#__PURE__*/ _jsx(SvgIcon, {
                        name: "chevron-down",
                        size: 16,
                        className: cx(styles.chevronIcon, _define_property({}, styles.chevronIconRotateUp, isExpanded))
                    })
                ]
            })
        ]
    }));
};
export default PartnersOverview;
